import { z } from 'zod';
import { PopulatedUserSchema } from '../user/user.schema';
import { PopulatedDepartmentSchema } from '../department/department.schema';
// The kind and user-ref schemas live in a leaf module to avoid a User↔OrgFunction
// import cycle (user.schema imports the ref); the link-source and held-ref schemas
// live there because the held ref extends the user ref.
// Re-exported here so consumers keep importing them from `orgFunction.schema`.
export { OrgFunctionKindSchema, UserOrgFunctionRefSchema, OrgFunctionLinkSourceSchema, HeldOrgFunctionRefSchema } from './org-function-ref.schema';
import { OrgFunctionKindSchema } from './org-function-ref.schema';
/**
 * OrgFunction Schema
 *
 * The single org-structure entity a person can belong to, merging the former
 * Team and Role entities under a `kind` discriminator. Only `name` and `kind`
 * are required; `lead` (Funktionsleiter), `department`, `email`, and
 * `description` are optional on BOTH kinds. A OrgFunction's member list is derived
 * by reverse query over the user links (mainRole / secondaryRoles) — never stored
 * here. The lead is the responsible person, not a member.
 */ export const OrgFunctionSchema = z.object({
    _id: z.string(),
    name: z.string(),
    kind: OrgFunctionKindSchema,
    email: z.email().optional(),
    description: z.string().optional(),
    lead: PopulatedUserSchema.optional(),
    department: PopulatedDepartmentSchema.optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    deletedAt: z.number().optional()
});
/**
 * Populated OrgFunction Schema
 *
 * Used when a OrgFunction reference is populated within another entity (a user's
 * mainRole / secondaryRoles, a process-step assignee / successor / helper).
 * Simplified for display; no members (membership is derived, never embedded).
 */ export const PopulatedOrgFunctionSchema = z.object({
    _id: z.string(),
    name: z.string(),
    kind: OrgFunctionKindSchema,
    email: z.string().optional(),
    description: z.string().optional(),
    lead: z.union([
        z.string(),
        PopulatedUserSchema
    ]).optional(),
    department: z.union([
        z.string(),
        PopulatedDepartmentSchema
    ]).optional(),
    deletedAt: z.number().optional()
});

//# sourceMappingURL=org-function.schema.js.map